module.exports = __webpack_public_path__ + "static/media/settings-icon.6df5cd0a.svg";